// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const LinkIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "Link/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12.586 4.586a2 2 0 1 1 2.828 2.828l-3 3a2 2 0 0 1-2.828 0 1 1 0 0 0-1.414 1.414 4 4 0 0 0 5.656 0l3-3a4 4 0 0 0-5.656-5.656l-1.5 1.5a1 1 0 1 0 1.414 1.414l1.5-1.5Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.586 9.586a2 2 0 0 1 2.828 0 1 1 0 1 0 1.415-1.414 4 4 0 0 0-5.657 0l-3 3a4 4 0 1 0 5.657 5.656l1.5-1.5a1 1 0 1 0-1.415-1.414l-1.5 1.5a2 2 0 1 1-2.828-2.828l3-3Z"
}));
export default LinkIcon;